import React from 'react';
import {Text, View} from 'react-native';
import styles from './DamagedVehicleCard.style';
import VehicleIcon from '../../../../trip/components/vehicle-icon/VehicleIcon.component';
import {CustomText} from '../../../../../components';
import {useTranslation} from 'react-i18next';

export default function DamagedVehicleCard(props) {
  const {
    item,
    children,
    leftChildren,
    hasIcon,
    containerStyle,
    hasReadyLabel = true,
  } = props;
  const {t} = useTranslation();

  return (
    <View style={[styles.container, containerStyle]}>
      {leftChildren}
      <View style={[styles.infoWrapper, hasIcon && {paddingRight: 8}]}>
        <Text style={styles.name}>{item?.name}</Text>
        {children}
      </View>
      <View style={styles.vehicleContainer}>
        {hasReadyLabel && (
          <View style={styles.readyContainer}>
            <CustomText size={8} font={'500'} color={'#06AD00'}>
              {t('ready_to_trip')}
            </CustomText>
          </View>
        )}
        {console.log(item?.VehicleBrand, 'item?.VehicleBrand')}
        {hasIcon && (
          <VehicleIcon
            size={40}
            VehicleBrand={item?.VehicleBrand || item?.Brand}
          />
        )}
      </View>
    </View>
  );
}
